import { PlusCircleFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { RoutingPaths } from "../../pages/routing/routingContainer";
import styles from "./newCaseStickyButton.module.less";

export default function NewCaseStickyButton(props: { caseAddRoute?: string }) {    
    return <div className={styles.newCaseWrapper}>
        <Link to={props.caseAddRoute || RoutingPaths.yourCaseAdd.route} className={styles.newCaseContainer}>
            <div className={styles.newCaseText}>Zgłoś nową sprawę</div>
            <PlusCircleFilled className={styles.icon}/>
        </Link>
    </div>;
}
